export default {
  reviewCompleteHeader: 'Revizuiește și Finalizează',
  participants: 'Participanți',
  enterParticipantInfoText:
    'Vă rugăm să introduceți detaliile necesare pentru a continua la plată.',
  purchaser: 'Cumpărător',
  firstName: 'Prenume',
  lastName: 'Nume de familie',
  email: 'Email',
  optionalEmail: 'Email: (opțional)',
  'phone:': 'Telefon',
  participantFieldPlaceholder:
    'Adaugă nou sau selectează un participant existent',
  reservationSummary: 'Rezumatul Rezervării',
  editParticipantsDetails: 'Editează Detaliile Participantului',
  participantDetails: 'Detalii',
  duplicatePurchaserText: 'La fel ca și Cumpărătorul',
  phone: 'Telefon',
  addParticipant: '{{tierLabel}} suplimentar',
  participant: 'Participant',
  removeParticipant: 'Elimină',
  experienceCheckoutCompleted: 'Plata Experienței Finalizată',
  experienceCartCheckout: 'Plata Coșului de Experiențe',
  experienceLimitReached:
    'Ne pare rău, această experiență a atins numărul maxim de participanți',
  payment: 'Plată',
  duration: 'Durată',
  discountCode: 'Cod de Reducere',
  removeCode: 'Elimină Codul',
  invalidCodeValidation: 'Cod de Cupon Invalid',
  networkErrorDiscountCode: 'A apărut o eroare din partea noastră',
  onlyOneCouponCodeAllowed: 'Este permis un singur cod de cupon',
  creditCodeHasAlreadyBeenApplied: 'Codul de credit a fost deja aplicat',
  discount: 'Reducere',
  promo: 'Promoție',
  promoCode: 'Cod promoțional',
  apply: 'Aplică',
  total: 'Total',
  subTotal: 'Subtotal',
  includes: 'Include',
  and: 'și',
  addHostNotes: 'Adaugă note pentru gazda ta',
  brandAggreementText:
    'Sunt de acord sau certific că sunt autorizat în numele participantului(ilor) să accept termenii și condițiile',
  termsAggreementValidation: 'Vă rugăm să acceptați termenii',
  firstNameValidation: 'Prenumele este obligatoriu',
  lastNameValidation: 'Numele de familie este obligatoriu',
  emailValidation: {
    emailRequiredText: 'Emailul este obligatoriu',
    invalidEmail: 'Adresă de email invalidă',
    not_specified: 'Adresă de email incorectă',
  },
  phoneValidation: {
    'Invalid Phone Number': 'Număr de telefon invalid',
    not_specified: 'Invalid',
    phoneRequiredText: 'Numărul de telefon este obligatoriu',
  },
  participantFirstNameValidation: 'Prenumele participantului este obligatoriu',
  participantLastNameValidation:
    'Numele de familie al participantului este obligatoriu',
  complete: 'Finalizează',
  '404Message': 'Nu a fost găsit',
  waiting: 'Se așteaptă...',
  complimentary: 'Gratuit',
  confirmationHeader: 'Experiența ta a fost rezervată!',
  confirmationText:
    'Un email de confirmare a fost trimis la {{email}} cu detalii suplimentare',
  viewAll: 'Vezi toate Experiențele',
  paymentMethod: 'Metoda de Plată',
  creditCard: 'Card de Credit',
  roomCharge: 'Taxă de Cameră',
  memberCharge: 'Taxă de Membru',
  roomOrReservationNumber: 'Număr de Cameră sau Număr de Confirmare',
  roomNumber: 'Număr de Cameră',
  roomNumberLegacy: 'Număr de Cameră / Cod de Confirmare',
  memberNumber: 'Număr de Membru',
  kicc: 'Plată Ușoară',
  chargeValidation: 'Numărul de Cameră și Numele de familie sunt obligatorii',
  memberNumberValidation: 'Numărul de Membru este obligatoriu',
  invalidRoomNumber: 'Numărul camerei este invalid',
  invalidRoomNumberLegacy:
    'Numărul camerei sau codul de confirmare este invalid',
  invalidMemberNumber: 'Numărul de membru este invalid',
  invalidPhoneNumber: 'Numărul de telefon este invalid',
  requiredPhoneNumber: 'Numărul de telefon este obligatoriu',
  guestNameIsRequired: 'Numele oaspetelui este obligatoriu',
  roomNumberIsRequired: 'Numărul de Cameră este obligatoriu',
  roomNumberIsRequiredLegacy:
    'Numărul de Cameră sau Codul de Confirmare este obligatoriu',
  roomOrReservationNumberIsRequired:
    'Numărul de cameră sau numărul de confirmare este obligatoriu',
  cardNumberIncomplete: 'Număr de Card Incomplet',
  lastNameValidationError: 'Numele de familie este obligatoriu',
  isReqd: 'este obligatoriu',
  reservationCode: 'Număr de Rezervare/Confirmare',
  nonHotelGuest: 'Oaspete din afara hotelului',
  onPropertyGuest: 'Oaspete la proprietate',
  preArrivalGuest: 'Oaspete înainte de sosire',
  cardNumber: 'Număr de card',
  pmsValidationErrorMessage:
    'Nume de familie sau număr de cameră sau număr de confirmare invalid',
  pmsDateValidationErrorMessage:
    'Ne pare rău! Data experienței nu se încadrează între data sosirii și data plecării dvs.',
  fullName: 'Nume Complet',
  checkout: 'Plată',
  editParticipants: 'Editează Participanții',
  private: 'Privat',
  browseAllExperieces: 'Răsfoiește toate experiențele',
  payWithCreditCard: 'Plătește cu Card de Credit',
  payWithRoomCharge: 'Plătește cu Taxă de Cameră',
  payWithMemberCharge: 'Plătește cu Taxă de Membru',
  payWith: 'Plătește cu',
  bookBulkErrorByCard:
    'A apărut o problemă la confirmarea rezervării. Cardul dvs. nu a fost debitat.',
  bookBulkErrorByRoomCharge: 'Nume de familie și număr de cameră invalide.',
  bookBulkErrorByMemberCharge: 'Nume de familie și număr de membru invalide.',
  reviewCancellation: 'Revizuiește Anularea',
  selectAReservationToCancel: 'Selectează o rezervare pentru anulare',
  confirmCancellation: 'Confirmă anularea',
  cancellable: 'Anulabil',
  cancelled: 'Anulat',
  deadlinePassed: 'Termen depășit',
  noCancellations: 'Fără anulări',
  reviewReschedule: 'Rezervarea ta',
  selectAReservationToReschedule: 'Selectează o rezervare pentru reprogramare',
  confirmReservation: 'Confirmă rezervarea',
  confirm: 'Confirmă',
  selectADateAndTime: 'Selectează o dată și oră',
  noOtherSessionsAvailableForThisExperience:
    'Nu există alte sesiuni disponibile pentru această experiență.',
  thisReservationCanNoLongerBeRescheduledPleaseEmail:
    'Această rezervare nu mai poate fi reprogramată. Vă rugăm să trimiteți un email la {{brandEmail}}',
  thisReservationCannotBeRescheduled:
    'Această rezervare nu poate fi reprogramată',
  noTimesAvailable: 'Nu sunt ore disponibile',
  noBookingsAvailable: 'Nu sunt rezervări disponibile',
  youPaid: 'Ați plătit',
  refund: 'Rambursare',
  yourRefund: 'Rambursarea dvs.',
  yourRefundWillBeProcessedToTheOriginalPayment:
    'Rambursarea dvs. va fi procesată către plata originală.',
  thisReservationCanNoLongerBeCancelledPleaseEmail:
    'Această rezervare nu mai poate fi anulată. Vă rugăm să trimiteți un email la {{brandEmail}}',
  reservationCancelled: 'Rezervare anulată',
  thisReservationCannotBeCancelled: 'Această rezervare nu poate fi anulată',
  thisReservationHasAlreadyBeenCancelled:
    'Această rezervare a fost deja anulată',
  theHotel: 'Hotelul',
  cancelling: 'Se anulează',
  somethingWentWrong: 'Ceva nu a funcționat corect',
  previouslyRefunded: 'Rambursat anterior',
  remainingBalance: 'Sold Rămas',
  notEnoughPoints: 'Puncte insuficiente',
  notEnoughPointsDescription:
    'Nu aveți suficiente Puncte World of Hyatt pentru a finaliza această achiziție.',
  currentPointsBalance: 'Sold curent de puncte: {{count, number}}',
  points: 'puncte',
  pointsWithCount_one: '{{count, number}} punct',
  pointsWithCount_other: '{{count, number}} puncte',
  payWithHyattPoints: 'Plătește cu Puncte Hyatt',
  pleaseSignIn: 'Vă rugăm să vă conectați',
  worldOfHyattPoints: 'Puncte World of Hyatt',
  bookBulkErrorByNotEnoughSeats:
    'Nu sunt suficiente locuri disponibile pentru sesiune. Vă rugăm să încercați o altă sesiune.',
  phoneNumber: 'Număr de telefon',
  requestToBookConfirmationText:
    'Un email de confirmare a fost trimis la {{email}}',
  reservationRescheduled: 'Rezervare reprogramată',
  yourReservationWasRescheduledTo: 'Rezervarea dvs. a fost reprogramată la',
  viewExperiences: 'Vezi experiențele',
  joinBook: 'Alătură-te și Rezervă',
  signInBook: 'Conectează-te și Rezervă',
  signAndJoin: 'Conectează-te sau Alătură-te pentru a Rezerva',
  signAndJoinDescription:
    'Experiențele FIND World of Hyatt sunt exclusive pentru membrii World of Hyatt. Conectați-vă sau alăturați-vă pentru a rezerva și a câștiga puncte. Preferați să nu vă alăturați? Puteți rezerva în continuare experiențe non-exclusive eliminând Experiența World of Hyatt din coș.',
  promoOrFind: 'Cod Promoțional sau Cod de Credit Find',
  hyattTermsAndConditions: 'Termeni și Condiții',
  hyattTermsAndConditionsAgreement:
    'Prin confirmarea acestei rezervări, accept politica de anulare. De asemenea, am citit și recunosc utilizarea informațiilor mele personale în conformitate cu',
  hyattTermsAndConditionsLink: 'Politicile de Confidențialitate Hyatt',
  hyattWaiverText:
    'Prin achiziționarea acestei experiențe, sunt de acord, înțeleg și recunosc, atât în numele meu, cât și în numele oricărei persoane care participă la experiența achiziționată de mine (dacă este cazul), următoarele',
  hyattWaiverLink: 'renunțare generală',
  priceDisclaimer: 'Include taxele înainte de impozite',
  curatedRecommendations: 'Recomandări selectate',
  moreExperiencesYouMightLike: 'Mai multe experiențe care v-ar putea plăcea',
  similarExperiencesAvailableToBookDirectly:
    'Experiențe similare disponibile pentru rezervare directă',
  experiencesAvailableAroundYourBookingDate:
    'Experiențe disponibile în jurul datei rezervării dvs.',
  confirmationEmailSent:
    'Am trimis confirmarea dvs. la {{email}} cu mai multe detalii.',
  youreBooked: 'Ați rezervat',
  purchaserInformation: 'Informații Cumpărător',
  requiredFieldIndicator: '* indică un câmp obligatoriu',
  resourceSelectionTitle: 'Alegeți opțiunile',
  resourceSelectionDescription:
    'Alegeți o opțiune pentru fiecare articol din rezervare.',
  resourceUnitLabel: '{{tierName}} {{number}}',
  selectResourceAttribute: 'Selectați {{attributeName}}',
  resourceValueSoldOut: '{{label}} (epuizat)',
  resourceValueUnavailableWith: '{{label}} (indisponibil cu {{picks}})',
  resourceOptionsUnavailable:
    'Nu am putut încărca opțiunile pentru această oră. Vă rugăm să încercați din nou.',
  resourceOptionsRetry: 'Încercați din nou',
  changeResourceSelections: 'Modificați alegerile',
};
